import { useState } from "react";
import { HomepageSearchBar } from "@pages/home/search/homepage-search-bar";
import { Box } from "@mui-wrapper";
import { SearchResults } from "@pages/home/search/search-results";
import { faroCoreApiClient } from "@api/faro-core-api-client";
import { SearchMembersTable } from "@pages/home/search/search-tables/search-members-tables/search-members-table";
import { SearchProjectsTable } from "@pages/home/search/search-tables/search-projects-tables/search-projects-table";
import { SearchWorkspacesTable } from "@pages/home/search/search-tables/search-workspaces-tables/search-workspaces-table";

/**
 * The home page content of the application.
 */
export function HomePage(): React.JSX.Element {
  // The actual search query that will be sent to the server
  const [searchQuery, setSearchQuery] = useState<string>("");

  return (
    <section>
      <Box sx={{ mx: 2.5 }} component="h2">
        Home
      </Box>
      <Box sx={{ my: 2.5, mr: 2.5, display: "flex", alignItems: "center" }}>
        <Box sx={{ flex: 1 }}>
          <HomepageSearchBar onSearchExecution={setSearchQuery} />
        </Box>
      </Box>

      {searchQuery.length > 0 && (
        <>
          <SearchResults
            subjectType="USER"
            searchQuery={searchQuery}
            searchFn={(query) =>
              faroCoreApiClient.admin.searchMembers({ search: query })
            }
            resultComponent={(results) => (
              <SearchMembersTable members={results} />
            )}
          />
          <SearchResults
            subjectType="COMPANY"
            searchQuery={searchQuery}
            searchFn={(query) =>
              faroCoreApiClient.admin.searchCompanies({ search: query })
            }
            resultComponent={(results) => (
              <SearchWorkspacesTable companies={results} />
            )}
          />
          <SearchResults
            subjectType="PROJECT"
            searchQuery={searchQuery}
            searchFn={(query) =>
              faroCoreApiClient.admin.searchProjects({ search: query })
            }
            resultComponent={(results) => (
              <SearchProjectsTable projects={results} />
            )}
          />
        </>
      )}
    </section>
  );
}
